import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { Link, useNavigate } from 'react-router-dom';
import { format, formatISO, subDays } from 'date-fns';
import { DEFAULT_DATE_FORMATE, DEFAULT_LOCAL_PATH } from '../../constents';
// import Period from '../Schedular/Appointment/period';
// import PeriodSelection from '../Schedular/Appointment/PeriodSelection';
import GoalPlanViewPopup from '../Patient/GoalPlanViewPopup';
import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  setTplanPeriod,
  updateTplanSerch,
} from '../../redux/slices/Notes/treatmentPlanSlice';
import DatePickerCalander from '../../Utilities/DatePickerCalander';

function TreatmentPlan() {
  const dispatch = useDispatch();

  const { user } = useSelector((store) => store.auth);
  const { tPlanPeriodFilter, treatmentGrid } = useSelector(
    (store) => store.treatmentPlan,
  );
  const {
    chartSerch,
    patSerch,
    dateAdded,
    reviewDate,
    provId,
    provSignSt,
    superVisor,
    superVisorSignSt,
    patSignSt,
    actionSt,
    payor,
    serviceCode,
    billSt,
  } = treatmentGrid;

  const [allData, setAllData] = useState(null);
  const [goalPlanViewPopup, setGoalPlanViewPopup] = useState(false);
  const [appointmentId, setAppointmentId] = useState(false);
  const [visitId, setVisitId] = useState(false);
  const [treatmentId, setTreatmentId] = useState(false);
  const [patientId, setPatientId] = useState(false);
  const [reviewed, setReviewed] = useState(0);
  const [status, setStatus] = useState(0);
  const [planType, setPlanType] = useState(0);
  const navigate = useNavigate();

  const [selectAll, setSelectAll] = useState(false);
  const [sucPrams, setSucPrams] = useState(false);
  const [markCosigner, setMarkCosigner] = useState(false);

  const [reload, setReload] = useState(false);
  function handleReload() {
    setReload(!reload);
  }

  useEffect(() => {
    if (tPlanPeriodFilter.startDate) {
      (async () => {
        try {
          const response = await post(
            'api/notes/TreatmentPlan/allTreatmentPlanList',
            {
              filterDate: `${format(
                new Date(tPlanPeriodFilter.startDate),
                'yyyy-MM-dd',
              )}|${format(new Date(tPlanPeriodFilter.endDate), 'yyyy-MM-dd')}`,
              dateAdded: dateAdded,
              reviewDate: reviewDate,
              provId: provId,
              provSignSt: provSignSt,
              superVisor: superVisor,
              superVisorSignSt: superVisorSignSt,
              patSignSt: patSignSt,
              actionSt: actionSt,
              payor: payor,
              serviceCode: serviceCode,
              billSt: billSt,
              chartNo: chartSerch,
              patientName: patSerch,
              staffUserId: user?.id,
            },
          );
          if (response.status === 200) {
            setAllData(response?.data);
            // setAppData(response?.data?.allAppointmentList);
            // setIsLoading(false);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    }
  }, [
    chartSerch,
    patSerch,
    dateAdded,
    reviewDate,
    provId,
    provSignSt,
    superVisor,
    superVisorSignSt,
    patSignSt,
    actionSt,
    payor,
    serviceCode,
    billSt,
    tPlanPeriodFilter,
    reload,
    user?.id,
  ]);

  useEffect(() => {
    if (allData?.tretPlan) {
      const allRowsSelected = allData?.tretPlan?.every((row) => row.selected);
      setSelectAll(allRowsSelected);
    }
  }, [allData?.tretPlan]);

  useEffect(() => {
    if (user?.id) {
      dispatch(
        updateTplanSerch({
          key: 'provId',
          value: user?.id,
        }),
      );
    }
  }, [user?.id, dispatch]);

  const handleSelectAll = () => {
    if (allData?.tretPlan) {
      const updatedRows = allData?.tretPlan.map((row) => ({
        ...row,
        selected: !selectAll,
      }));
      setAllData({ ...allData, tretPlan: updatedRows });
      setSelectAll(!selectAll);
    }
  };

  const handleAsignSuperviser = (e) => {
    const superId = e.target.value;
    const seltRowSoapId =
      allData?.tretPlan &&
      allData?.tretPlan.reduce((acc, data, i) => {
        if (data?.selected) {
          acc.push(`${data?.treatId}_${data?.type}`);
        }
        return acc;
      }, []);

    const selectedIndex = e.target.selectedIndex;
    const selectedText = e.target.options[selectedIndex].text;
    if (superId) {
      if (seltRowSoapId.length <= 0) {
        setUiMessage(
          'err',
          'Please select the note from the checkbox & then select co-signer from this dropdown.',
        );
      } else {
        setSucPrams([superId, seltRowSoapId.join(',')]);
        setMarkCosigner(
          `Do you want to assign this Co-Assign provider (<b>${selectedText}</b>) for below checked record ?`,
        );
      }
    }
  };

  const handleAsignSuperviserConfirm = async (args) => {
    const providerId = args[0];
    const soapIds = args[1];

    if ((providerId, soapIds)) {
      const response = await post(
        'api/patient/treatmentPlan/assignCoAssignProvider',
        {
          coAssignId: providerId,
          checkedRecord: soapIds,
          loginUserId: user?.id,
        },
      );
      if (response.status === 200) {
        setMarkCosigner(false);
        setUiMessage('suc', 'Co-Assign has been assigned to Selected record.');
        handleReload();
      }
    }
  };

  const handleViewTemplate = async (
    appId,
    visitId,
    treatId,
    patId,
    reviewed,
    status,
    type,
  ) => {
    if (status === '1') {
      navigate(
        `${DEFAULT_LOCAL_PATH}/patient/treatPlan/${patId}/${appId}/${visitId}/${treatId}`,
      );
    } else {
      setGoalPlanViewPopup(true);
      setAppointmentId(appId);
      setVisitId(visitId);
      setTreatmentId(treatId);
      setPatientId(patId);
      setReviewed(reviewed);
      setStatus(status);
      setPlanType(type);
    }
  };

  const handleRowSelect = (index) => {
    const updatedRows = [...allData?.tretPlan];
    updatedRows[index].selected = !updatedRows[index].selected;
    setAllData({ ...allData, tretPlan: updatedRows });
  };

  const handleDateFilter = (days, filterName) => {
    const date = new Date();
    const newDate = subDays(date, days);
    dispatch(
      setTplanPeriod({
        name: filterName,
        startDate: formatISO(newDate),
        endDate: formatISO(date),
      }),
    );
  };

  return (
    <main>
      <section>
        <div className="child-menu-body">
          <div className="bnc-mn-hdr">
            <div className="bill-dt-main-con">
              <div className="bill-days-blk">
                <span className="intake-head-inpt-main">
                  <span className="intake-head-hedding">Display:</span>
                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(90, '90D')}
                      checked={tPlanPeriodFilter?.name === '90D' ? true : false}
                    />
                    <span className="">90 days</span>
                  </span>

                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(60, '60D')}
                      checked={tPlanPeriodFilter?.name === '60D' ? true : false}
                    />
                    <span className="">60 days</span>
                  </span>

                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(30, '30D')}
                      checked={tPlanPeriodFilter?.name === '30D' ? true : false}
                    />
                    <span className="">30 days</span>
                  </span>
                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(7, '7D')}
                      checked={tPlanPeriodFilter?.name === '7D' ? true : false}
                    />
                    <span className="">7 days</span>
                  </span>
                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => {
                        dispatch(
                          setTplanPeriod({
                            name: 'Today',
                            startDate: formatISO(new Date()),
                            endDate: formatISO(new Date()),
                          }),
                        );
                      }}
                      checked={
                        tPlanPeriodFilter?.name === 'Today' ? true : false
                      }
                    />
                    <span className="">Today</span>
                  </span>

                  <div className="intake-serch-calander-sec">
                    <span className="intake-head-inpt-sec">
                      <input
                        type="radio"
                        name="radio2"
                        onChange={() => {
                          dispatch(
                            setTplanPeriod({
                              name: 'DR',
                              startDate: null,
                              endDate: formatISO(new Date()),
                            }),
                          );
                        }}
                        checked={
                          tPlanPeriodFilter?.name === 'DR' ? true : false
                        }
                      />
                    </span>
                    <span className="intake-serch-calander">
                      <DatePickerCalander
                        selectedDate={
                          tPlanPeriodFilter?.startDate
                            ? new Date(tPlanPeriodFilter?.startDate)
                            : null
                        }
                        setSelectedDate={(date) => {
                          if (date) {
                            dispatch(
                              setTplanPeriod({
                                name: 'DR',
                                startDate: formatISO(date),
                                endDate: tPlanPeriodFilter?.endDate,
                              }),
                            );
                          }
                        }}
                        className="add-task-date-picker"
                        style={{
                          width: '75px',
                        }}
                        dateFormat={DEFAULT_DATE_FORMATE}
                        maxDate={
                          tPlanPeriodFilter?.endDate
                            ? new Date(tPlanPeriodFilter?.endDate)
                            : new Date()
                        }
                        editFlag={tPlanPeriodFilter?.name !== 'DR'}
                      />
                    </span>
                    <span className="date-sep-blu-hdr">-</span>
                    <span className="intake-serch-calander">
                      <DatePickerCalander
                        selectedDate={
                          new Date(tPlanPeriodFilter?.endDate) || new Date()
                        }
                        setSelectedDate={(date) => {
                          if (date) {
                            dispatch(
                              setTplanPeriod({
                                name: 'DR',
                                startDate: tPlanPeriodFilter?.startDate,
                                endDate: formatISO(date),
                              }),
                            );
                          }
                        }}
                        className="add-task-date-picker"
                        style={{
                          width: '75px',
                        }}
                        dateFormat={DEFAULT_DATE_FORMATE}
                        minDate={
                          tPlanPeriodFilter?.startDate
                            ? new Date(tPlanPeriodFilter?.startDate)
                            : null
                        }
                        editFlag={tPlanPeriodFilter?.name !== 'DR'}
                      />
                    </span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div className="child-body-rw appt-sec-fst-rw">
            {/* <div className="appt-d-display">
              <Period
                periodFilter={tPlanPeriodFilter}
                setPeriodFilter={(obj) => dispatch(setTplanPeriod(obj))}
              />
              <PeriodSelection
                selectedPeriod={tPlanPeriodFilter}
                setPeriodFilter={(obj) => dispatch(setTplanPeriod(obj))}
              />
            </div> */}
            <div className="child-body-rw appt-sec-fst-new">
              <div className="appt-loc-val">
                <span className="orange-txt fontsize20">&#9632;</span>{' '}
                {allData?.planForUpdate} Treatment plans for Update
              </div>
              <div className="appt-loc-val">
                <span className="purple fontsize20">&#9632;</span>{' '}
                {allData?.planForReview} Treatment plans up for Review
              </div>
              <div className="appt-loc-val">
                <span className="red fontsize20">&#9632;</span>{' '}
                {allData?.pendingPlan} Treatment plans Pending
              </div>
            </div>
            <div className="appt-search">
              <span className="appt-loc-val hide">
                <span className="prnt-btn">Export excel</span>
              </span>
            </div>
          </div>
          <div className="c-mid-bdy-blk">
            <div className="t-plan-hdr">
              <span className="t-plan-lbl ns-col-0">
                <span className="">
                  <input
                    type="checkbox"
                    className=""
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </span>
                <span className="">
                  <select
                    className="appt-col-slct clear-left10"
                    onChange={(e) => handleAsignSuperviser(e)}
                  >
                    <option value="">Assign supervisor</option>
                    {allData?.allResource &&
                      allData?.allResource.map((note, idx) => {
                        return (
                          <option key={idx} value={note?.id}>
                            {note?.resName}
                          </option>
                        );
                      })}
                  </select>
                </span>
              </span>
              <span className="t-plan-lbl pc-col-2">
                <span className="bold">Chart#</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search Chart#..."
                  value={chartSerch || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'chartSerch',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-2">
                <span className="bold">Patient</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search Patient..."
                  value={patSerch || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'patSerch',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-2">
                <span className="bold">Added</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search date..."
                  value={dateAdded || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'dateAdded',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-2">
                <span className="bold">Review</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search date..."
                  value={reviewDate || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'reviewDate',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Clinician</span>
                <select
                  className="appt-col-slct"
                  value={provId || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'provId',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.allResource &&
                    allData?.allResource.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.resName}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-4">
                <span className="bold">Clinician Sign.</span>
                <select
                  className="appt-col-slct"
                  value={provSignSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'provSignSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.signStatus &&
                    allData?.signStatus.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Supervisor</span>
                <select
                  className="appt-col-slct"
                  value={superVisor || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'superVisor',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.allResource &&
                    allData?.allResource.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.resName}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-4">
                <span className="bold">Supervisor Sign.</span>
                <select
                  className="appt-col-slct"
                  value={superVisorSignSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'superVisorSignSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.signStatus &&
                    allData?.signStatus.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-4">
                <span className="bold">Patient Sign.</span>
                <select
                  className="appt-col-slct"
                  value={patSignSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'patSignSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.signStatus &&
                    allData?.signStatus.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Action</span>
                <select
                  className="appt-col-slct"
                  value={actionSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'actionSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.actionFilter &&
                    allData?.actionFilter.map((filter, idx) => {
                      return (
                        <option key={idx} value={filter?.id}>
                          {filter?.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Payor</span>
                <select
                  className="appt-col-slct"
                  value={payor || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'payor',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All Payor</option>
                  {allData?.allInsurance &&
                    allData?.allInsurance.map((ins, idx) => {
                      return (
                        <option key={idx} value={ins?.id}>
                          {ins?.insName}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Service Code</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search Service Code..."
                  value={serviceCode || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'serviceCode',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-2 bold">Dx</span>

              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Billing</span>
                <select
                  className="appt-col-slct"
                  value={billSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateTplanSerch({
                        key: 'billSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.billStatus &&
                    allData?.billStatus.map((bill, idx) => {
                      return (
                        <option key={idx} value={bill?.id}>
                          {bill?.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-2 bold">$</span>
            </div>
            {allData?.tretPlan && allData.tretPlan.length > 0 ? (
              <div className="t-plan-bdy">
                {allData?.tretPlan &&
                  allData?.tretPlan.map((plan, idx) => {
                    const ltClass = idx % 2 === 0 ? '' : 'alt-rw';
                    return (
                      <div key={idx} className={`t-plan-bdy-rw ${ltClass}`}>
                        <span className="t-plan-lbl ns-col-0">
                          <input
                            type="checkbox"
                            className=""
                            checked={
                              plan?.selected && plan?.selected ? true : false
                            }
                            onChange={() => handleRowSelect(idx)}
                          />
                        </span>
                        <span className="t-plan-lbl pc-col-2">
                          {plan?.chartNo}
                        </span>

                        <span className="t-plan-lbl pc-col-2">
                          <Link
                            to={`${DEFAULT_LOCAL_PATH}/patient/treatPlan/${plan?.user_id}`}
                          >
                            {plan?.patientName}
                          </Link>
                        </span>

                        <span className="t-plan-lbl pc-col-2">
                          {plan?.addedDt}
                        </span>
                        <span className="t-plan-lbl pc-col-2">
                          {plan?.reviewDt}
                        </span>
                        <span
                          className="t-plan-lbl pc-col-1"
                          style={{ flexBasis: '15%' }}
                        >
                          {plan?.clinician}
                        </span>
                        <span className="t-plan-lbl pc-col-4 maroon">
                          {plan?.clinicianSignSt}
                        </span>
                        <span className="t-plan-lbl pc-col-1">
                          {plan?.supervisor}
                        </span>
                        <span className="t-plan-lbl pc-col-4 maroon ">
                          {plan?.supervisorSignSt}
                        </span>
                        <span className="t-plan-lbl pc-col-4 maroon">
                          {plan?.patSign}
                        </span>
                        <span className="t-plan-lbl pc-col-1">
                          <span
                            className=""
                            onClick={() =>
                              handleViewTemplate(
                                plan?.appId,
                                plan?.visitId,
                                plan?.treatId,
                                plan?.user_id,
                                plan?.reviewed,
                                plan?.status,
                                plan?.type,
                              )
                            }
                          >
                            <Link to="">{plan?.actionLabel}</Link>
                          </span>
                        </span>
                        <span className="t-plan-lbl pc-col-1">
                          {plan?.payor}
                        </span>
                        <span className="t-plan-lbl pc-col-1">
                          {plan?.procName}
                        </span>
                        <span className="t-plan-lbl pc-col-2">{plan?.dx}</span>
                        <span className="t-plan-lbl pc-col-1">
                          {plan?.billingSt}
                        </span>
                        <span className="t-plan-lbl pc-col-2">{plan?.amt}</span>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <p className="no-appoinmnts-here">No Pt. Information !!</p>
            )}
          </div>
        </div>
      </section>
      {goalPlanViewPopup && (
        <GoalPlanViewPopup
          close={() => setGoalPlanViewPopup(false)}
          patientId={patientId}
          appointmentId={appointmentId}
          visitId={visitId}
          treatId={treatmentId}
          reviewed={reviewed}
          status={status}
          type={planType}
          handleTreatPlanListReload={handleReload}
        />
      )}
      {markCosigner && (
        <ConfirmDialog
          title={'Confirm'}
          bodytext={<div dangerouslySetInnerHTML={{ __html: markCosigner }} />}
          closeDialog={() => setMarkCosigner(false)}
          successDialog={handleAsignSuperviserConfirm}
          sucPrams={sucPrams}
        />
      )}
    </main>
  );
}

export default TreatmentPlan;
